import React, { useCallback } from "react";
import Box from "@mui/material/Box";
import { ProductInput } from "../../../../../../components/input/ProductInput/ProductInput";
import { ProductOption } from "../../../../../../components/input/ProductInput/types";

interface ProductsFilterProps {
  value: number[];
  onChange: (value: number[]) => void;
}

export const ProductsFilter: React.FC<ProductsFilterProps> = React.memo(
  ({ value, onChange }) => {
    const handleProductSelect = useCallback(
      (products: ProductOption[]) => {
        const productIds = products.map((p) => Number(p.value));
        onChange(productIds);
      },
      [onChange]
    );

    return (
      <Box id="install-products-filter" sx={{ mb: 1 }}>
        <ProductInput
          selectedProductIds={value}
          onProductsSelect={handleProductSelect}
        />
      </Box>
    );
  }
);
